import React from 'react';
import { graphql } from 'gatsby';

import useIsMobile from '@/hooks/useIsMobile';
import { LinkType } from '../Link';
import VisaComparisonTableBlockMobile from './VisaComparisonTableBlock/VisaComparisonTableBlockMobile';
import VisaComparisonTableBlockDesktop from './VisaComparisonTableBlock/VisaComparisonTableBlockDesktop';
export type VisaComparisonTableBlockType = {
  id: string;
  __typename?: string;
  contentful_id?: string;
  title: string;
  subtitleMultipleLine: {
    subtitle: string;
  };

  classicPrimaryLink?: LinkType;
  classicSecondaryLink?: LinkType;
  goldPrimaryLink?: LinkType;
  goldSecondaryLink?: LinkType;
  platinumPrimaryLink?: LinkType;
  platinumSecondaryLink?: LinkType;
};
type Props = VisaComparisonTableBlockType;
const VisaComparisonTableBlock: React.FC<Props> = (props) => {
  const isMobile = useIsMobile();

  if (isMobile) return <VisaComparisonTableBlockMobile {...props} />;
  else return <VisaComparisonTableBlockDesktop {...props} />;
};

export default VisaComparisonTableBlock;
export const visaComparisonTableBlockFragmentQuery = graphql`
  fragment VisaComparisonTableBlockFragment on ContentfulVisaComparisonTableBlock {
    id
    contentful_id
    __typename
    title
    subtitleMultipleLine: subtitle {
      subtitle
    }
    classicImage {
      gatsbyImageData(width: 188)
      ...ImageFragment
    }
    classicPrimaryLink {
      ...LinkFragment
    }
    classicSecondaryLink {
      ...LinkFragment
    }
    goldImage {
      gatsbyImageData(width: 188)
      ...ImageFragment
    }
    goldPrimaryLink {
      ...LinkFragment
    }
    goldSecondaryLink {
      ...LinkFragment
    }
    platinumImage {
      gatsbyImageData(width: 188)
      ...ImageFragment
    }
    platinumPrimaryLink {
      ...LinkFragment
    }
    platinumSecondaryLink {
      ...LinkFragment
    }
  }
`;
